export const StatusTypeIndexLabelMap: {[key: string]: string} = {
    0: "0:未使用",
    1: "1:利用中",
    2: "2:デモ用",
    9: "9:返却"
};

